// Lifecycle states of a bulk project validation job (mirrors the API BulkProjectValidationStatus).
export const BulkProjectValidationStatus = {
  InProgress: "InProgress",
  ValidationComplete: "VALIDATION_COMPLETE",
  Failed: "Failed",
  CreationInProgress: "CREATING",
  Completed: "COMPLETED",
};

// One project row parsed from the uploaded sheet, together with its validation outcome.
export interface IBulkProjectRow {
  rowNumber: number;
  projectName: string;
  projectType: string;
  reviewPeriodFromDate: string;
  reviewPeriodToDate: string;
  projectStartDate: string;
  projectEndDate: string;
  riskProgramType: string;
  codingReviewMode: string;
  lob: string;
  codingModel: string;
  measurementYear: string;
  reportingYear: string;
  productType: string;
  group: string;
  copyProviderPacket: string;
  sourceProjectName: string;
  failedReason: string;
  createdProjectId?: number;
  isValid: boolean;
}

// Status/result of an asynchronous bulk project validation run, returned when starting a run and on each poll.
export interface IBulkProjectValidationResult {
  loadId: string;
  orgId: number;
  fileKey: string;
  status: string;
  totalRequested: number;
  totalPassed: number;
  totalFailed: number;
  rows: IBulkProjectRow[];
  createdProjectIds: number[];
  errorMessage: string;
}
